import { useEffect, useState } from 'react'

import { useApi, useInitData } from '../../../../hooks'

import { getEmailProfileAISummaryUnavailableData } from './useEmailProfileAISummaryData.utils'

export function useEmailProfileAISummaryData({ getSummaryData, isInitiated }) {
  const api = useApi()

  const { ai_features: aiFeatures } = useInitData()

  const [summaryData, setSummaryData] = useState(null)

  const isEnabled =
    getSummaryData != null && Boolean(aiFeatures?.email_summary_generation)

  async function loadSummaryData(apiConfig) {
    if (isEnabled) {
      return getSummaryData(apiConfig)
        .then(response => {
          if (response) {
            setSummaryData(response.data.email_summary)
          }
        })
        .catch(() => {
          setSummaryData(getEmailProfileAISummaryUnavailableData())
        })
    }
  }

  function setSummaryWidgetData(data) {
    setSummaryData(prevSummaryData => ({ ...prevSummaryData, ...data }))
  }

  useEffect(() => {
    if (isInitiated && isEnabled) {
      api.call(loadSummaryData)
    }

    return () => {
      api.abort()
    }
  }, [isInitiated])

  return {
    loadSummaryData,
    setSummaryWidgetData,
    summaryData,
  }
}
